import { MessageCircle } from 'lucide-react';
import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { ComingSoon } from '../../components/admin/ui';

export function CRMInteractionsPage() {
  return (
    <AdminLayout
      title="Interactions"
      description="Journal de toutes les communications avec vos clients"
    >
      <ComingSoon
        icon={MessageCircle}
        title="Suivi des Interactions"
        description="Centralisez tous les échanges avec vos clients et prospects en un seul endroit."
        features={[
          'Timeline unifiée de toutes les interactions',
          'Emails, appels, réunions et notes',
          'Enregistrement automatique des communications',
          'Recherche et filtres avancés',
          'Analytics des interactions',
        ]}
      />
    </AdminLayout>
  );
}
